module.exports = __webpack_public_path__ + "static/media/CQY_27.22_RGB-iso2022_WHITE.b23f7afb.png";